export default __webpack_public_path__ + "static/media/054.57ac4c46.jpg";